export const trackPlausibleEvent = (eventName: string, props: Record<string, any>) => {
  if (window.plausible) {
    window.plausible(eventName, { props });
  }
};
